import { useCallback, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  LinearProgress,
  FormGroup,
  FormLabel,
} from "@material-ui/core";

import Api from "lib/api/httpRequestHelper";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import useLogs from "hooks/logs";
import { IsMobile } from "utils/is-mobile";

export default function DialogManutencaoInfoComplementar({
  open,
  handleClose,
  selectedStore,
}) {
  const { setLocalStorageApiProblem } = useLogs();

  const [nomeComercial, setNomeComercial] = useState(
    selectedStore.NomeComercial
  );
  const [horarioFuncionamento, setHorarioFuncionamento] = useState(
    selectedStore.HorarioFuncionamento
  );
  const [urlLogoLoja, setUrlLogoLoja] = useState(selectedStore.UrlLogoLoja);
  const [urlInstagram, setUrlInstagram] = useState(
    selectedStore.UrlPerfilInstagram
  );
  const [urlFacebook, setUrlFacebook] = useState(
    selectedStore.UrlPerfilFacebook
  );
  const [atualizando, setAtualizando] = useState(false);
  const snackbar = useSnackbar();
  const [disabledButton, setDisableButton] = useState(true);

  const isMobile = IsMobile();

  const submit = useCallback(async () => {
    setAtualizando(true);
    const verifyNomeComercial = nomeComercial
      ? `&nomeComercial=${nomeComercial}`
      : `&nomeComercial=`;
    const verifyLogoLoja = urlLogoLoja
      ? `&urlLogoLoja=${urlLogoLoja}`
      : `&urlLogoLoja=`;
    const verifyInstagram = urlInstagram
      ? `&urlInstagram=${urlInstagram}`
      : `&urlInstagram=`;
    const verifyFacebook = urlFacebook
      ? `&urlFacebook=${urlFacebook}`
      : `&urlFacebook=`;
    const verifyHorarioFuncionamento = horarioFuncionamento
      ? `&horarioFuncionamento=${horarioFuncionamento}`
      : `&horarioFuncionamento=`;

    await Api.postParams(
      "update-complementary-info",
      "storeadditionalinfo",
      "?idLoja=" +
        selectedStore.IdLoja +
        verifyNomeComercial +
        verifyLogoLoja +
        verifyInstagram +
        verifyFacebook +
        verifyHorarioFuncionamento,
      true
    )
      .then((res) => {
        snackbar.showMessage(
          `Informações Complementares da loja ${
            selectedStore.Apelido || selectedStore.RazaoSocial
          } atualizadas com sucesso!`,
          {
            severity: "success",
          }
        );
        handleClose(res.Result);
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(
          "Ocorreu um erro ao atualizar informações complementares. Verifique os parâmetros informados.",
          {
            severity: "error",
          }
        );
        setLocalStorageApiProblem({
          idMenuAccess: "131",
          screen: "Manutenção de Informações Complementares de Loja",
          problem: `Erro na chamada do endpoint update-complementary-info - ${error}`,
        });
      })
      .finally(() => setAtualizando(false));
  }, [
    selectedStore.IdLoja,
    selectedStore.Apelido,
    selectedStore.RazaoSocial,
    nomeComercial,
    urlLogoLoja,
    urlInstagram,
    urlFacebook,
    horarioFuncionamento,
    snackbar,
    handleClose,
  ]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
    >
      <DialogTitle id="alert-dialog-title">
        <span>
          <Typography variant="h3" component="h3">
            Informações complementares da Loja
          </Typography>
        </span>
      </DialogTitle>
      <DialogContent style={{ padding: "0 1.5rem 1.5rem" }}>
        <FormGroup>
          <FormLabel>Nome Comercial</FormLabel>
          <TextField
            value={nomeComercial}
            onChange={(event) => {
              setNomeComercial(event.target.value);
              setDisableButton(false);
            }}
            variant="outlined"
            disabled={atualizando}
            onInput={(e) =>
              (e.target.value = e.target.value.toString().slice(0, 150))
            }
          />
        </FormGroup>
        <FormGroup>
          <FormLabel>Horários de Funcionamento</FormLabel>
          <TextField
            multiline
            value={horarioFuncionamento}
            onChange={(event) => {
              setHorarioFuncionamento(event.target.value);
              setDisableButton(false);
            }}
            variant="outlined"
            disabled={atualizando}
            onInput={(e) =>
              (e.target.value = e.target.value.toString().slice(0, 1000))
            }
          />
        </FormGroup>
        <FormGroup>
          <FormLabel>URL do logo da loja</FormLabel>
          <TextField
            value={urlLogoLoja}
            onChange={(event) => {
              setUrlLogoLoja(event.target.value);
              setDisableButton(false);
            }}
            variant="outlined"
            disabled={atualizando}
            onInput={(e) =>
              (e.target.value = e.target.value.toString().slice(0, 300))
            }
          />
        </FormGroup>
        <FormGroup>
          <FormLabel>Instagram</FormLabel>
          <TextField
            value={urlInstagram}
            onChange={(event) => {
              setUrlInstagram(event.target.value);
              setDisableButton(false);
            }}
            variant="outlined"
            disabled={atualizando}
            onInput={(e) =>
              (e.target.value = e.target.value.toString().slice(0, 300))
            }
          />
        </FormGroup>
        <FormGroup>
          <FormLabel>Facebook</FormLabel>
          <TextField
            value={urlFacebook}
            onChange={(event) => {
              setUrlFacebook(event.target.value);
              setDisableButton(false);
            }}
            variant="outlined"
            disabled={atualizando}
            onInput={(e) =>
              (e.target.value = e.target.value.toString().slice(0, 300))
            }
          />
        </FormGroup>
        {atualizando && (
          <div>
            <span>Atualizando informações...</span>
            <LinearProgress />
          </div>
        )}
      </DialogContent>
      <DialogActions
        style={{
          display: "flex",
          justifyContent: isMobile ? "center" : "flex-end",
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        <Button
          component={Box}
          onClick={handleClose}
          disabled={atualizando}
          style={{ width: isMobile && "100%" }}
        >
          Cancelar
        </Button>
        <Button
          style={{ width: isMobile && "100%" }}
          component={Box}
          variant="contained"
          onClick={submit}
          disabled={atualizando || disabledButton}
        >
          Atualizar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
